import { createReducer } from '@reduxjs/toolkit'
import { ProfessionalInterface } from '../../../models/interfaces/professional.interface'
import {
  closeModalCropImage,
  getProfessionalProfile,
  postProfessionalProfileImage,
  showModalCropImage
} from './profile.actions'
import { storageUserGet } from '../../../storage/storageUser'

export type ModalCropImageData = {
  url?: string
}

interface TrainingWorkoutState {
  professional: ProfessionalInterface | null
  isVisible: boolean
  modalCropImageData: ModalCropImageData | null
}

const initialState: TrainingWorkoutState = {
  professional: storageUserGet() as unknown as ProfessionalInterface,
  isVisible: false,
  modalCropImageData: null
}

export const profileReducer = createReducer(initialState, builder => {
  builder.addCase(getProfessionalProfile.fulfilled, (state, action) => ({
    ...state,
    professional: action.payload.data
  }))
  builder.addCase(postProfessionalProfileImage.fulfilled, (state, action) => {
    if (state.professional) {
      state.professional.imagePath = action.payload.data.imagePath
    }
  })
  builder.addCase(closeModalCropImage, (state) => ({
    ...state,
    modalCropImageData: null,
    isVisible: false
  }))
  builder.addCase(showModalCropImage, (state, action) => ({
    ...state,
    modalCropImageData: action.payload,
    isVisible: true
  }))
})
